import {Component, Inject, OnInit} from '@angular/core';
import {
  MEETING_STATUS_DURING_REGISTRATIONS,
  MEETING_TYPE_ENTRANCE_EXAM,
  MEETING_TYPE_EXAM
} from '../../../shared/services/dict.service';
import {Meeting} from '../../../shared/interface/meeting';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface ExamSelectDialogData {
  insuranceCompanyId?: number;
  missingExamKeys: string[];
}

@Component({
  selector: 'app-exam-select-dialog',
  templateUrl: './exam-select-dialog.component.html',
  styleUrls: ['./exam-select-dialog.component.scss']
})
export class ExamSelectDialogComponent implements OnInit {

  readonly MEETING_TYPE_EXAM = MEETING_TYPE_EXAM;
  readonly MEETING_TYPE_ENTRANCE_EXAM = MEETING_TYPE_ENTRANCE_EXAM;
  readonly MEETING_STATUS_DURING_REGISTRATIONS = MEETING_STATUS_DURING_REGISTRATIONS;

  insuranceCompanyId?: number = null;
  missingExamKeys?: string[] = null;

  constructor(
    public dialogRef: MatDialogRef<ExamSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExamSelectDialogData,
  ) {
    this.insuranceCompanyId = data.insuranceCompanyId;
    this.missingExamKeys = data.missingExamKeys;
  }

  ngOnInit(): void {
  }

  selectedMeeting(meeting: Meeting): void {
    this.dialogRef.close(meeting);
  }
}
